/* eslint-disable react/prop-types */
import React from 'react';

// Generic status pill — caller supplies color/background/border so it stays
// domain-agnostic (e.g. track "Live" = green, "draft" = amber).
const StatusPill = ({ label, color, background, border, dot = true }) => (
  <span
    style={{
      display: 'inline-flex',
      alignItems: 'center',
      gap: 7,
      padding: '5px 12px',
      borderRadius: 999,
      background,
      border: '1px solid ' + border,
      color,
      fontSize: '10.5px',
      fontWeight: 800,
      letterSpacing: '0.7px',
      textTransform: 'uppercase',
    }}
  >
    {dot && (
      <span
        style={{ width: 6, height: 6, borderRadius: '50%', background: color }}
      />
    )}
    {label}
  </span>
);

export default StatusPill;
